import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type AlertEntry, type AlertsState } from '../types';

const registerAlertCase: CaseReducer<AlertsState, PayloadAction<AlertEntry>> = (
  state,
  action,
) => {
  const existingIndex = state.items.findIndex(
    item =>
      item.scope === action.payload.scope && item.id === action.payload.id,
  );

  if (existingIndex === -1) {
    state.items.push(action.payload);

    return state;
  }

  state.items[existingIndex] = action.payload;

  return state;
};

export { registerAlertCase };
